<template>
  <JapchaeTteokbokkiBody />
</template>

<script>
import JapchaeTteokbokkiBody from '../molecules/JapchaeTteokbokkiBody.vue'


export default {
  name: 'JapchaeTteokbokkiView',
  components: {
    JapchaeTteokbokkiBody,
  }
}
</script>
